var utils = require('frontend-controller/lib/utils');

module.exports = {
	extends: [
		'/',
		'templates',
		'base',
		'form',
		'form'
	],

	config: {
		dirtyModelPersistent: true
	},

	model: {
		listOfCategoryDataEntries: {}
	},

	methods: {
		// prevent this filter form from being submitted
		submit: function(){},

		// tell parent which filter has been changed
		onChange: function(isRelationChange, changeDone, fieldData){
			var dirties = this.model.dirtyFields || {};
			var filterOptions = utils.copy((dirties.data || {}).attributes);
			filterOptions.listOfCategoryDataIDs = {};
			var categoryDataID
			utils.forEach((dirties.data || {}).children || {}, function(category){
				utils.forEach((category || {}).data || [], function(entityCategory){
					if((categoryDataID = ((entityCategory || {}).attributes || {}).categoryDataID)){
						filterOptions.listOfCategoryDataIDs[categoryDataID] = true;
					}
				});
			});
			filterOptions.listOfCategoryDataIDs = Object.keys(filterOptions.listOfCategoryDataIDs);

			if(!fieldData || fieldData.fieldCode === 'search' || (changeDone && (fieldData || {}).isLastRelationElement)){
				this.triggerFind('filterChanged', filterOptions);
			}
		}
	},

	hooks: {
		onRefresh: function($element, options){
			this.model.dirtyFields = {};
			this.fieldToModel('search', undefined);
			this.refresh(false);
		}
	}
};